module.exports = __webpack_public_path__ + "static/media/dash-spend-card.02c5da17.svg";